<template>
    <div class="map-container-height">
        <!--Will Not Toggle Properly if put into a class...Leave inline-->
        <div @dblclick="zoomIn" @contextmenu="zoomOut" style="width: 100%; height: 100%;" id='map'></div>
        <task-details :toggle="toggleDetailsTask" :show-dialog="detailsTaskDialog"></task-details>
    </div>
</template>

<script>
    import mapboxgl from 'mapbox-gl';
    import {mapActions, mapGetters} from 'vuex'
    import TaskDetails from '../../components/jobTasks/Details'
    import mapHelpers from '../../utils/helpers/mapHelpers'

    export default {
        name: 'task-map',
        props: {
            tab: {
                type: String,
                required: true
            },
            updateTaskList: {
                type: Function,
                required: true
            },
            planningModeActive: {
                type: Boolean,
                required: true
            },
            selectedTasks: {
                type: Set,
                required: true
            },
            assignTaskCallback: {
                type: Function,
                required: true
            }
        },
        data() {
            return {
                accessToken: 'pk.eyJ1IjoiaG9za2luc3QiLCJhIjoiY2s5M2N6NHprMDEwNDNkbWJieThzbm1hNiJ9.0F7I8B6DKLxTzAXg1oN9Hw',
                mapStyle: 'mapbox://styles/mapbox/outdoors-v12',
                coordinates: [-122.9110,49.2057],
                currentMarkers: [],
                jobTaskToEdit: {},
                detailsTaskDialog: false,
                clickCounter: 0,
                flying: false,
                emptyTask: { //prevent console errors by passing this to the edit pin dialog when the selected task is null
                    taskType: '',
                    address: '',
                    notes: '',
                }
            }
        },
        mounted() {
            this.createMap();
        },
        components: {
            TaskDetails
        },
        methods: {
            ...mapActions({
                select: 'jobTasks/getById',
                clearSelectedTask: 'jobTasks/clearSelected'
            }),
            createMap() {
                mapboxgl.accessToken = this.accessToken
                // init the map
                this.map = new mapboxgl.Map({
                    container: 'map',
                    style: this.mapStyle,
                    minzoom: 1.3,
                    center: this.coordinates,
                    zoom: 10
                })
                this.map.on('load', () => {
                    this.map.resize();
                });
                this.map.on('moveend', () => {
                    this.addMarkers()
                    if(this.flying && this.selected.id){
                        for (const marker of this.currentMarkers){
                            if(marker.taskId === this.selected.id){
                                marker.togglePopup()
                            }
                        }
                    }
                    this.flying = false
                })
                this.map['doubleClickZoom'].disable()
                this.map.addControl(new mapboxgl.NavigationControl());
                this.map.addControl(
                    new mapboxgl.GeolocateControl({
                        positionOptions: {
                            enableHighAccuracy: true
                        },
                        showAccuracyCircle: false,
                        trackUserLocation: true
                    })
                );
                this.addMarkers()

            },
            zoomIn() {
                let z = this.map.getZoom()
                this.map.flyTo({ zoom: z + 2, speed: 0.2, curve: 1, essential: true })
            },
            zoomOut (e) {
                e.preventDefault()
                this.clickCounter++
                if (this.clickCounter === 2) {
                    let z = this.map.getZoom()
                    this.map.flyTo({ zoom: z - 2, speed: 0.2, curve: 1, essential: true })
                    this.clickCounter = 0
                }
            },
            selectTask (task) {
                if(this.planningModeActive){
                    this.assignTaskCallback(task.id)
                }
                this.select(task.id)
            },
            addMarkers() {
                this.currentMarkers.forEach(marker => { marker.remove() })
                this.currentMarkers = []
                this.mapTaskArray.forEach(task => {
                    if(!task){
                        return
                    }
                    let marker
                    const markerType = mapHelpers.parseType(task)

                    // Check if task is selected, get selected element if so
                    const isSelected = task.id === this.selected.id && this.selected;
                    const element = (isSelected) ? mapHelpers.getSelectedElement() : mapHelpers.getElement(markerType);

                    // Tasks requiring a flagger should have their icon background changed to a shade of blue
                    const currentColor = element.style.backgroundColor;
                    const flaggerColor = this.$vuetify.theme.themes.light.flagger;
                    const selectedColor = this.$vuetify.theme.themes.light.success;
                    element.style.backgroundColor = (task.needsFlagger) ? flaggerColor : currentColor;
                    if(this.selectedTasks.has(task.id)){
                        element.style.backgroundColor = selectedColor
                    }
                    marker = new mapboxgl.Marker({ element: element });
                    marker.taskId = task.id
                    const popup = new mapboxgl.Popup({ closeOnClick: false, offset: 10 })
                        .setHTML(`<h5>${this.selected.address}</h5>`);
                    popup.setLngLat([task.longitude, task.latitude])
                    if(task.id === this.selected.id){
                        marker.setPopup(popup)
                    }
                    marker.setLngLat([task.longitude, task.latitude])
                        .addTo(this.map)
                    marker.getElement().addEventListener('click', () => {
                        if(this.selected.id !== task.id){
                            this.selectTask(task);
                        }
                    });
                    this.currentMarkers.push(marker)

                })
            },
            async fly () {
                this.flying = true;
                if (this.selected && this.selected.longitude && this.selected.latitude ) {
                    this.map.flyTo({
                        center: [this.selected.longitude, this.selected.latitude],
                        zoom: 13
                    })
                }
                else {
                    this.map.flyTo({
                        center: this.coordinates,
                        zoom: 10
                    })
                }
                this.map.resize()
            },
            async openDetail () {
                await this.toggleDetailsTask()
            },
            toggleDetailsTask () {
                if(this.detailsTaskDialog){
                    if(this.selected.routeId != null){
                        this.clearSelectedTask()
                    }
                    this.updateTaskList()
                }
                this.detailsTaskDialog = !(this.detailsTaskDialog)
            },
        },
        watch: {
            mapTaskLocations () {
                this.addMarkers()
            },
            async selected () {
                if(!this.planningModeActive) {
                    await this.fly()
                    return
                }
                this.addMarkers()
                if(this.selected.id){
                    for (const marker of this.currentMarkers){
                        if(marker.taskId === this.selected.id){
                            marker.togglePopup()
                        }
                    }
                }
            },
            async clickCounter () {
                await mapHelpers.sleep(500).then(() => this.clickCounter = 0)
            },
            tab() {
                this.map.resize()
            },
            planningModeActive () {
                this.addMarkers()
            }
        },
        computed: {
            ...mapGetters({
                mapTaskLocations: 'jobTasks/mapTaskLocations',
                selected: 'jobTasks/selectedJobTask',
            }),
            mapTaskArray () {
                if(Array.isArray(this.mapTaskLocations)) {
                    return this.mapTaskLocations
                } else {
                  return [this.mapTaskLocations]
                }
            }
        }
    }
</script>
<style>
    .map-container-height{
        height: 100%;
    }
    .mapboxgl-ctrl-top-right .mapboxgl-ctrl {
        margin: 14px 12px 0 0 !important;
    }
    .mapboxgl-canvas {
        height: 100% !important;
    }
    .mapboxgl-marker:hover {
        cursor: pointer;
    }
    .marker-general {
        background-size: cover;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        cursor: pointer;
        background-color: white
    }
    .marker-selected {
        background-size: cover;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        cursor: pointer;
        background-image: url('../../assets/markerIcons/star.png');
        background-color: white
    }
    .marker-pin-overhead {
        background-image: url('../../assets/markerIcons/pin-oh.png');
    }
    .marker-pin-underground {
        background-image: url('../../assets/markerIcons/pin-ug.png');
    }
    .marker-pin-unknown {
        background-image: url('../../assets/markerIcons/pin-unk.png');
    }
    .marker-two-trip-overhead {
        background-image: url('../../assets/markerIcons/twotrip-oh.png');
    }
    .marker-two-trip-underground {
        background-image: url('../../assets/markerIcons/twotrip-ug.png');
    }
    .marker-two-trip-unknown {
        background-image: url('../../assets/markerIcons/twotrip-unk.png');
    }
    .marker-meet {
        background-image: url('../../assets/markerIcons/meet.png');
        background-color: #5a5a5a
    }
    .marker-demo {
        background-image: url('../../assets/markerIcons/volcano.png');
    }
    .marker-on-after {
        background-image: url('../../assets/markerIcons/alert.png');
    }
    .marker-rush {
        background-image: url('../../assets/markerIcons/fire.png');
    }
    .marker-confined {
        background-image: url('../../assets/markerIcons/confined.png');
    }
</style>
